import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { EpicRefined } from 'interfaces/middleware'
import { of, merge } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { CCOnboardingActions, CCReplaceCardAction } from 'components/features/creditCard/creditCardStore/actions'
import { CC_REPLACE_URL } from 'components/features/creditCard/creditCardStore/endpoints'
import FloatingPaneAction, { ModifyFloatingPaneAction } from 'actions/floatingPanesActions'
import { CREDIT_CARD_PANE } from 'components/features/creditCard/creditCardStore/floatingPane'

export const ccReplaceRequestEpic: EpicRefined<CCOnboardingActions | AjaxCatchExtraActions | FloatingPaneAction> = (action$, _, { post }) => action$.pipe(
  filterRequest(CCReplaceCardAction.type),
  mergeMap((action) => {
    return post({ url: CC_REPLACE_URL, params: { uid: action.payload.params.uid }}, { body: action.payload.params }).pipe(
      mergeMap(({ response }) => {
        return merge(
          of(new ModifyFloatingPaneAction({
            type: CREDIT_CARD_PANE,
            mode: 'replaceCard',
            step: 'result',
            reason: action.payload.params.reason,
          })),
          of(action.success(response)),
        )
      }),
      ajaxCatch((error) => of(action.fail({ errorCode: error.status, errorsMap: error.response })))
    )
  }),
)
